import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import { ChangeEvent, useState } from 'react';
import { Card, Form } from 'react-bootstrap';

import ReactTextareaAutosize from 'react-textarea-autosize';
import AttachmentPreview from 'components/common/AttachmentPreview';
import { convertFileToAttachment } from 'helpers/utils';
import ImageAttachmentPreview from 'components/common/ImageAttachmentPreview';

import {
    faMicrophone,
    faPaperclip
} from '@fortawesome/free-solid-svg-icons';

import { useChatContext } from './AIChatProvider';

const AIChatContentFooter = () => {
    const { currentConversation, sendMessage } = useChatContext();

    const [messageText, setMessageText] = useState('');
    const [fileAttachment, setFileAttachment] = useState<File | null>(null);
    const [imageAttachments, setImageAttachments] = useState<File[]>([]);

    const sentMessage = () => {
        if (
            currentConversation &&
            (messageText || fileAttachment || imageAttachments.length > 0)
        ) {

            sendMessage(messageText);
            setMessageText('');
            setImageAttachments([]);
            setFileAttachment(null);
        }
    };

    return (
        <Card.Footer>
            <ReactTextareaAutosize
                minRows={1}
                maxRows={6}
                value={messageText}
                placeholder="Type your message..."
                onChange={({ target: { value } }) => setMessageText(value)}
                className="chat-textarea form-control outline-none border-0 scrollbar resize-none mb-1 p-0 fs-8 fw-normal"
            />

            {fileAttachment && (
                <div className="mb-2">
                    <AttachmentPreview
                        attachment={convertFileToAttachment(fileAttachment)}
                        size="xl"
                        handleRemove={() => setFileAttachment(null)}
                    />
                </div>
            )}

            {imageAttachments && (
                <div className="mb-2 d-flex gap-2">
                    {imageAttachments.map((attachment, index) => (
                        <ImageAttachmentPreview
                            key={index}
                            image={URL.createObjectURL(attachment)}
                            handleClose={() => {
                                setImageAttachments(
                                    imageAttachments.filter((_, i) => index !== i)
                                );
                            }}
                        />
                    ))}
                </div>
            )}

            <div className="d-flex gap-3 align-items-center">

                <div>
                    <Button className="p-0">
                        <label
                            className="text-900 fs-9 cursor-pointer"
                            htmlFor="attachments"
                        >
                            <FontAwesomeIcon icon={faPaperclip} />
                        </label>
                    </Button>
                    <Form.Control
                        className="d-none"
                        type="file"
                        id="attachments"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
                        onChange={({
                            target: { files }
                        }: ChangeEvent<HTMLInputElement>) => {
                            files && setFileAttachment(files[0]);
                        }}
                    />
                </div>

                <Button className="p-0 text-900 fs-9">
                    <FontAwesomeIcon icon={faMicrophone} />
                </Button>


                <Button
                    variant="primary"
                    className="ms-auto"
                    type="submit"
                    onClick={sentMessage}
                >
                    Send
                </Button>
            </div>
        </Card.Footer>
    );
};

export default AIChatContentFooter;
